import React from 'react';
import { Option } from '@here/hds-select';
// eslint-disable-next-line no-new
new Option();
const HDSOption = React.forwardRef(({ selected, disabled, variant, children, className, ...rest }, ref) => (React.createElement("hds-option", { ...(selected && { selected }), ...(disabled && { disabled }), variant: variant, ...(className && { class: className }), ref: ref, ...rest }, children)));
export default HDSOption;
//# sourceMappingURL=HDSOption.js.map